var map = {
	"./about/african-parliament-homepage.png": "bf37",
	"./about/african-parliament.png": "32e8",
	"./chart/southAfrica.png": "3a2b",
	"./dummy/all-sectors.png": "7663",
	"./dummy/avatar.png": "fb61",
	"./dummy/circle.png": "c196",
	"./dummy/logo-vertical.c6814486.png": "c9e5",
	"./dummy/sh-klogos.95bcf679.png": "2d93",
	"./flags/all-africa.png": "68b3",
	"./flags/burkina-faso.png": "125b",
	"./flags/ethiopia.png": "3d4b",
	"./flags/flag-kenya.png": "df71",
	"./flags/flag-nigeria.png": "04b2",
	"./flags/flag-south-africa.png": "2159",
	"./flags/flag-southafrica-big.png": "9bcf",
	"./flags/flag-southafrica-medium.png": "3c28",
	"./flags/kenya.png": "ccda",
	"./flags/nigeria.png": "e1df",
	"./flags/south-africa.png": "17a2",
	"./icons/circle.svg": "9d5a",
	"./icons/globe.svg": "c7c9",
	"./icons/icon-arrow-down.svg": "f570",
	"./icons/icon-arrow-n.svg": "f093",
	"./icons/icon-arrow-point.svg": "8085",
	"./icons/icon-arrow-right-white.svg": "8d4d",
	"./icons/icon-arrow-right.svg": "24ad",
	"./icons/icon-avatar.svg": "3fbf",
	"./icons/icon-check-big.svg": "28e9",
	"./icons/icon-close-big.svg": "dceb",
	"./icons/icon-close-white.svg": "042c",
	"./icons/icon-close.svg": "952b",
	"./icons/icon-delete.svg": "ad46",
	"./icons/icon-dislike.svg": "bafe",
	"./icons/icon-down-arrow.svg": "5534",
	"./icons/icon-download-white.svg": "5ab2",
	"./icons/icon-download.svg": "fdb0",
	"./icons/icon-edit.svg": "f7e1",
	"./icons/icon-external-link-white.png": "4bbf",
	"./icons/icon-external-link-white.svg": "be9a",
	"./icons/icon-facebook.svg": "c210",
	"./icons/icon-google.svg": "878a",
	"./icons/icon-hierarchy.svg": "0eb7",
	"./icons/icon-info-blue-big.svg": "fc6f",
	"./icons/icon-info-white.svg": "ee89",
	"./icons/icon-info.svg": "3744",
	"./icons/icon-launch.svg": "6bcf",
	"./icons/icon-like.svg": "38b5",
	"./icons/icon-line-horizontal.svg": "e6d1",
	"./icons/icon-line.svg": "ebe3",
	"./icons/icon-linkedin.svg": "af62",
	"./icons/icon-menu.svg": "9bb6",
	"./icons/icon-minus.svg": "e687",
	"./icons/icon-plus.svg": "bf0c",
	"./icons/icon-question.svg": "dccc",
	"./icons/icon-save-white.svg": "7d5a",
	"./icons/icon-share-white.svg": "ff46",
	"./icons/icon-share.svg": "5903",
	"./icons/icon-triangle.png": "668c",
	"./icons/icon-twitter.svg": "032e",
	"./icons/line-4.svg": "b065",
	"./icons/triangle.svg": "44d8",
	"./icons/website.png": "7923",
	"./logo/ap.png": "f892",
	"./logo/beta-launch.png": "8fdc",
	"./logo/cfa.png": "0ff9",
	"./logo/gates.png": "e030",
	"./logo/ihub.png": "b3ec",
	"./logo/logo-black.png": "44ce",
	"./logo/logo-vertical.png": "3741",
	"./logo/logo.png": "7872",
	"./org/gates.png": "cfd1",
	"./org/koko.png": "1c99",
	"./org/sh-klogos.png": "d781",
	"./organogram/line-right.svg": "96b7",
	"./profile/default_user.jpg": "2688",
	"./sdgs/lg/affordable-and-clean-energy.png": "d8ab",
	"./sdgs/lg/clean-water-and-sanitation.png": "8567",
	"./sdgs/lg/climate-action.png": "2175",
	"./sdgs/lg/decent-work-and-economic-growth.png": "9c58",
	"./sdgs/lg/end-poverty.png": "b4c0",
	"./sdgs/lg/gender-equality.png": "aa21",
	"./sdgs/lg/good-health-and-well-being.png": "36c7",
	"./sdgs/lg/industry-innovation-and-infrastructure.png": "4fb9",
	"./sdgs/lg/life-below-water.png": "cbc4",
	"./sdgs/lg/life-on-land.png": "1146",
	"./sdgs/lg/partnerships-for-the-goals.png": "920b",
	"./sdgs/lg/peace-justice-and-strong-institutions.png": "6826",
	"./sdgs/lg/quality-education.png": "d496",
	"./sdgs/lg/reduced-inequalities.png": "0426",
	"./sdgs/lg/responsible-consumption-and-production.png": "202d",
	"./sdgs/lg/sustainable-cities-and-communities.png": "8cf3",
	"./sdgs/lg/zero-hunger.png": "bb04",
	"./sdgs/sm/affordable-and-clean-energy.png": "c212",
	"./sdgs/sm/clean-water-and-sanitation.png": "15fb",
	"./sdgs/sm/climate-action.png": "cf0d",
	"./sdgs/sm/decent-work-and-economic-growth.png": "5f50",
	"./sdgs/sm/end-poverty.png": "36e1",
	"./sdgs/sm/gender-equality.png": "0cee",
	"./sdgs/sm/good-health-and-well-being.png": "f5c0",
	"./sdgs/sm/industry-innovation-and-infrastructure.png": "1e48",
	"./sdgs/sm/life-below-water.png": "e5bf",
	"./sdgs/sm/life-on-land.png": "1076",
	"./sdgs/sm/partnerships-for-the-goals.png": "e591",
	"./sdgs/sm/peace-justice-and-strong-institutions.png": "32cb",
	"./sdgs/sm/quality-education.png": "0039",
	"./sdgs/sm/reduced-inequalities.png": "e336",
	"./sdgs/sm/responsible-consumption-and-production.png": "519d",
	"./sdgs/sm/sustainable-cities-and-communities.png": "0411",
	"./sdgs/sm/zero-hunger.png": "c71a",
	"./social/email.svg": "5c92",
	"./social/email__green.svg": "eaa6",
	"./social/facebook.svg": "0fc0",
	"./social/facebook__green.svg": "df05",
	"./social/facebook_black.svg": "af32",
	"./social/instagram__green.svg": "5e99",
	"./social/linkedin.svg": "ccf6",
	"./social/linkedin__green.svg": "6653",
	"./social/linkedin_black.svg": "b305",
	"./social/logo-facebook.svg": "1651",
	"./social/logo-instagram.svg": "34e9",
	"./social/logo-linkedin.svg": "8751",
	"./social/logo-linkedin2.svg": "cc48",
	"./social/logo-mail.svg": "dbda",
	"./social/logo-mail2.svg": "dcb8",
	"./social/logo-twitter.svg": "5303",
	"./social/n.svg": "fa9b",
	"./social/share_black.svg": "f33c",
	"./social/twitter.svg": "0ca1",
	"./social/twitter__green.svg": "a99d",
	"./social/twitter_black.svg": "56ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33db";